module.exports = __webpack_public_path__ + "static/media/meet.0d6d4954.svg";